import React from 'react';
import ModalComponent from '../../../../../../components/modal/index';
import FieldComponent from '../../../../../../components/field/index';
import patients from '../../../../../../services/patients/index';

export default class AddPatient extends React.Component {
    state = {
        fields: {
            name: "",
            lastname: "",
            phone: ""
        },
        errors: {
            name: "",
            lastname: "",
            phone: ""
        }
    }

    validate = () => {
        let errors = Object.assign({}, this.state.errors)
        let hasError = false;

        if(!this.state.fields.name) {
            errors.name = "Porfavor introduzca un nombre."
            hasError = true;
        }

        if(!this.state.fields.lastname) {
            errors.lastname = "Porfavor introduzca un apellido."
            hasError = true;
        }

        this.setState({errors: errors})

        return hasError
    }

    submit = (e) => {
        e.preventDefault();
        if(!this.validate()) {
            patients.insert({
                name: this.state.fields.name,
                lastname: this.state.fields.lastname,
                phone: this.state.fields.phone
            }, (err, patient) => {
                this.props.addPatient(patient)
            })
        }
    }

    onInputChange = (e) => {
        let {name, value} = e.target
        let fields = Object.assign({}, this.state.fields)
        let errors = Object.assign({}, this.state.errors)
        fields[name] = value
        errors[name] = ""
        this.setState({fields: fields, errors: errors})
    }

    render() {
        if(!this.props.isActive)
            return null;

        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Agregar cliente</p>
                    </header>
                    <section className="modal-card-body">
                        <form id="form" onSubmit={this.submit}>
                            <FieldComponent label="Nombre *" error={this.state.errors.name}
                                name="name" onInputChange={this.onInputChange} icon="user"
                            />
                            <FieldComponent label="Apellido *" error={this.state.errors.lastname}
                                name="lastname" onInputChange={this.onInputChange} icon="user" />
                            <FieldComponent label="Teléfono" error={this.state.errors.phone}
                                name="phone" onInputChange={this.onInputChange} icon="phone" />
                        </form>
                    </section>
                    <footer className="modal-card-foot">
                        <button form="form" className="button is-primary" type="submit">
                            Agregar
                        </button>
                    </footer>
                </div>
            </ModalComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/components/add-patient/index.js